import { branding } from "./utils";

export class Table {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Table";
    this.scene = "Table";
    this.data = [];
    this.page = 50;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      options.table.forEach((element, index) => {
        let i = index + 1;
        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "10"; // Number
          }).value = element?.variables?.badge;
        } catch (err) {}
        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "20"; // Number
          }).value = element?.position;
        } catch (err) {}

        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "21"; // Number
          }).value = element?.team;
        } catch (err) {}

        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "11"; // Number
          }).value = element?.indicator;
        } catch (err) {}

        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "22"; // Number
          }).value = element?.Column1;
        } catch (err) {}

        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "23"; // Number
          }).value = element?.Column2;
        } catch (err) {}

        try {
          xml.payload.field.find((item) => {
            return item.attr.name === "0" + i + "24"; // Number
          }).value = element?.Column3;
        } catch (err) {}
      });

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
      }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
